export const Close = '/icons/icon-close.svg'
export const PreviousMatch = '/icons/arrow-up.svg'
export const ArrowRight = '/icons/arrow-right.svg'
export const ArrowLeft = '/icons/arrow-left.svg'
export const NextMatch = '/icons/arrow-down.svg'
export const ExtensionDefaultIcon = `/icons/extensionDefaultIcon.png`
export const Refresh = `/icons/refresh.svg`
